import { z } from 'zod';
import { uuid } from './posting.js';
/**
 * Der Antwortvertrag des Schreibprotokolls — `V-vertrag3` (2026-08-29).
 *
 * `apps/api/src/audit/audit.service.ts` führte `AuditEntry` bislang als
 * eigene Form; der OpenAPI-Erzeuger blieb an `GET /api/v1/audit` deshalb
 * `[UNGEKLÄRT]`.
 */
/**
 * Die Akteursart, wie sie das Postgres-Enum `actor_kind` führt — `'user'`,
 * `'system'`, `'token'` (Migration `0001`, um `'token'` erweitert in `0108`).
 *
 * **Hier und nicht in `system.ts`**, obwohl der Anfrage-Debugger der erste
 * Vertrag ist, der alle drei Werte herausgibt: Die Akteursart gehört zum
 * Protokollbegriff dieses Projekts und nicht zu einer Betriebsansicht. Wer sie
 * dort abschriebe, hätte eine zweite Liste, die beim nächsten Enum-Wert nicht
 * mitwächst — genau die Fehlerklasse, die `pnpm api:enums:check` jagt.
 *
 * **`auditEntrySchema.actorKind` unten führt seit `C-audittyp` (2026-09-01)
 * alle drei Werte über `actorKindSchema` selbst.** Bis dahin war das Feld
 * bewusst auf `'user'`/`'system'` verengt, weil das Schreibprotokoll nur
 * diese beiden auslieferte — eine echte Teilmenge wäre keine Abschrift
 * gewesen. Seitdem `common/audit-write.ts` (Auftrag `C-tokenakteur`, Migration
 * `0109`) Zeilen mit `actor_kind = 'token'` schreibt und `AuditService.list`
 * sie ungefiltert zurückgibt (`apps/api/src/audit/audit.service.ts`), war die
 * Verengung keine Einschränkung mehr, sondern eine Lücke: Ein Token-Akteur
 * kam über `GET /api/v1/audit` zurück, ohne dass der Vertrag ihn kannte.
 */
export const actorKindSchema = z.enum(['user', 'system', 'token']);
/** Ein Eintrag des Schreibprotokolls, wie er nach aussen geht. */
export const auditEntrySchema = z
    .object({
    /** `bigint` und deshalb als Zeichenkette — ab 2^53 wäre eine Zahl still ungenau. */
    id: z.string(),
    occurredAt: z.string(),
    actorId: uuid.nullable(),
    actorKind: actorKindSchema,
    action: z.string(),
    entityTable: z.string(),
    entityId: z.string(),
    /** `jsonb` ohne feste Form — je Aktion andere Felder, nicht erfunden. */
    payload: z.unknown(),
    correlationId: uuid,
})
    .strict();
/**
 * Die Antworthülle von `GET /api/v1/audit` — `{ entries: [...] }`. Der Umschlag lebt neben seinem
 * Elementschema, damit Server und Oberfläche dieselbe Hülle prüfen (Handbuch §3.969).
 */
export const auditListResponseSchema = z.object({ entries: z.array(auditEntrySchema).readonly() }).strict();
//# sourceMappingURL=audit.js.map